import { useMemo } from 'react';
import { useCheckDomainAvailability } from '../api/mutations';

export enum DomainSearchStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Unsupported = 'UNSUPPORTED',
}

export function useDomainSearch() {
  const {
    data,
    mutate: searchDomain,
    isPending: isSearching,
    isError,
    reset: resetSearch,
  } = useCheckDomainAvailability();

  const searchStatus = useMemo<DomainSearchStatus>(() => {
    if (isError) {
      return DomainSearchStatus.Unsupported;
    }
    if (data) {
      return data.availability.available ? DomainSearchStatus.Available : DomainSearchStatus.Unavailable;
    }
  }, [isError, data]);

  return { searchDomain, isSearching, searchStatus, resetSearch };
}
